import { Form as initForm, salvar } from "../../../service/seguranca/usuario";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CardSeplag from "../../../components/CardSeplag";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { InputMask } from "primereact/inputmask";
import RotuloSeplag from "../../../components/RotuloSeplag";
import { useHistory } from "react-router-dom";
import { SelectButton } from "primereact/selectbutton";

import Vinculo from "./vinculo";
import Perfil from "./perfil";

import { useFormik } from "formik";

import {
  printToast,
  summaryCriacaoSucessoPadrao,
  detailCriacaoSucessoPadrao,
  summaryAlteracaoSucessoPadrao,
  detailAlteracaoSucessoPadrao,
  getFormErrorMessage,
  isFormFieldValid,
  classNames,
} from "../../../config/global";

const Usuario = () => {
  const optSexo = [
    { name: "Feminino", value: "F" },
    { name: "Masculino", value: "M" },
  ];
  const [form, setForm] = useState(initForm);
  const location = useLocation();
  let history = useHistory();
  useEffect(() => {
    if (location.state) {
      setForm(location.state.data);
    } else {
      setForm(initForm);
    }
  }, []);

  function titleCard() {
    let titulo =
      form.pessoa != null && form.pessoa.nomePessoa != ""
        ? "Usuário(a): " + form.pessoa.nomePessoa
        : "Novo(a) Usuário(a)";
    return <span>{titulo}</span>;
  }

  const tab1HeaderTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button type="button" onClick={options.onClick} className={classSelected}>
          <i className="pi pi-users" style={{ marginRight: ".3em", fontSize: "1.5rem" }} />
          {options.titleElement}
        </Button>
      </>
    );
  };

  const tab2HeaderTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button type="button" onClick={options.onClick} className={classSelected} style={{ marginLeft: ".3em" }}>
          <i className="pi pi-link" style={{ marginRight: ".3em", fontSize: "1.5rem" }} />
          {options.titleElement}
        </Button>
        <br />
      </>
    );
  };

  const tab3HeaderTemplate = (options) => {
    let classSelected = options.selected ? "p-button-raised p-button-info" : "p-button-raised p-button-secondary";
    return (
      <>
        <Button type="button" onClick={options.onClick} className={classSelected} style={{ marginLeft: ".6em" }}>
          <i className="pi pi-id-card" style={{ marginRight: ".3em", fontSize: "1.5rem" }} />
          {options.titleElement}
        </Button>
        <br />
      </>
    );
  };

  const voltar = () => {
    history.push({ pathname: "/usuarios", state: {} });
  };

  function changeNome(value) {
    let tmpForm = { ...formik.values };
    if (value != null) {
      tmpForm.pessoa.nomePessoa = value;
    }
    setForm(tmpForm);
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: form,
    validate: (data) => {},
    onSubmit: async (data) => {
      let reg = /(\.)|(\/)|(\-)/g;
      let jsonPost = {
        ...data,
        nomeApresentacao: data.pessoa.nomePessoa,
      };
      let summary =
        data.pessoa && data.pessoa.idenPessoa > 0 ? summaryAlteracaoSucessoPadrao : summaryCriacaoSucessoPadrao;
      let detail =
        data.pessoa && data.pessoa.idenPessoa > 0 ? detailAlteracaoSucessoPadrao : detailCriacaoSucessoPadrao;

      salvar(jsonPost).then((res) => {
        setForm(res);
        printToast({ summary, detail });
        //onSalvar && onSalvar();
      });
    },
  });

  return (
    <>
      <CardSeplag title={titleCard()}>
        <TabView className="sm-invisibleWeb">
          <TabPanel header="Identificação" headerTemplate={tab1HeaderTemplate}>
            <CardSeplag title="Identificação">
              <form onSubmit={formik.handleSubmit} className="p-grid">
                <div className="grid line-height-4 col-12">
                  <div className="field col-12 md:col-8 ">
                    <RotuloSeplag nome="Nome" obrigatorio={true}>
                      <InputText
                        type="text"
                        value={formik.values.pessoa.nomePessoa}
                        onChange={formik.handleChange}
                        id="pessoa.nomePessoa"
                        name="pessoa.nomePessoa"
                        placeholder="Nome"
                        disabled={formik.values.pessoa.flagOrigem == "SEAP"}
                      />
                    </RotuloSeplag>
                  </div>
                  <div className="col-12 md:col-4 ">
                    <RotuloSeplag nome="Sexo" cols="12" obrigatorio={true}>
                      <div className="field">
                        <SelectButton
                          optionLabel="name"
                          style={{ padding: "0.1rem " }}
                          value={formik.values.pessoa.flagSexo}
                          options={optSexo}
                          onChange={formik.handleChange}
                          id="pessoa.flagSexo"
                          name="pessoa.flagSexo"
                          disabled={formik.values.pessoa.flagOrigem == "SEAP"}
                        />
                      </div>
                    </RotuloSeplag>
                  </div>
                  <div className="field col-12 md:col-4 ">
                    <RotuloSeplag nome="CPF" obrigatorio={true}>
                      <InputMask
                        value={formik.values.pessoa.numrCpf}
                        onChange={formik.handleChange}
                        id="pessoa.numrCpf"
                        name="pessoa.numrCpf"
                        mask="999.999.999-99"
                        placeholder="999.999.999-99"
                        disabled={formik.values.pessoa.flagOrigem == "SEAP"}
                      />
                    </RotuloSeplag>
                  </div>
                  <div className="field col-12 md:col-4 ">
                    <RotuloSeplag nome="Email" obrigatorio={true}>
                      <InputText
                        type="text"
                        value={formik.values.pessoa.descEmail}
                        onChange={formik.handleChange}
                        id="pessoa.descEmail"
                        name="pessoa.descEmail"
                        placeholder="Email"
                        disabled={formik.values.pessoa.flagOrigem == "SEAP"}
                      />
                    </RotuloSeplag>
                  </div>

                  <div className="field col-12 md:col-4 ">
                    <RotuloSeplag nome="Login" obrigatorio={true}>
                      <InputText
                        type="text"
                        value={formik.values.login}
                        onChange={formik.handleChange}
                        id="login"
                        name="login"
                        placeholder="Login"
                        disabled={formik.values.pessoa.flagOrigem == "SEAP"}
                      />
                    </RotuloSeplag>
                  </div>

                  <div className="field col-12 md:col-4 ">
                    <RotuloSeplag nome="Data de Nascimento" cols="12 6" obrigatorio={true}>
                      <InputText
                        type="text"
                        value={formik.values.pessoa.dataNascimento}
                        onChange={formik.handleChange}
                        id="pessoa.dataNascimento"
                        name="pessoa.dataNascimento"
                        placeholder="99/99/9999"
                        mask="99/99/9999"
                        disabled={formik.values.pessoa.flagOrigem == "SEAP"}
                      />
                    </RotuloSeplag>
                  </div>

                  <div className="field col-12 md:col-4 ">
                    <RotuloSeplag nome="Telefone Pessoal" cols="12 6" obrigatorio={true}>
                      <InputMask
                        value={formik.values.pessoa.numrTelefoneCelular}
                        onChange={formik.handleChange}
                        id="pessoa.numrTelefoneCelular"
                        name="pessoa.numrTelefoneCelular"
                        mask="(99)99999999"
                        placeholder="(99)99999-9999"
                        disabled={formik.values.pessoa.flagOrigem == "SEAP"}
                      />
                    </RotuloSeplag>
                  </div>
                  <div className="field col-12 md:col-4 ">
                    <RotuloSeplag nome="Telefone Celular" cols="12 6" obrigatorio={true}>
                      <InputMask
                        value={formik.values.pessoa.numrTelefonePessoal}
                        onChange={formik.handleChange}
                        id="pessoa.numrTelefonePessoal"
                        name="pessoa.numrTelefonePessoal"
                        mask="(99)99999999?9"
                        placeholder="(99)99999-9999"
                        disabled={formik.values.pessoa.flagOrigem == "SEAP"}
                      />
                    </RotuloSeplag>
                  </div>
                </div>
                <div className="p-fluid grid">
                  <div className="field col-12 md:col-8 ">&nbsp;</div>
                  <div className="field col-12 md:col-2 ">
                    <Button type="button" className="p-button-secondary" onClick={voltar}>
                      <span className="pi pi-arrow-left p-button-icon p-button-icon-left"></span>
                      <span className="p-button-label">Voltar </span>
                    </Button>
                  </div>
                  <div className="field col-12 md:col-2 ">
                    <Button
                      label="Salvar"
                      icon={"pi pi-check"}
                      autoFocus
                      className="p-button-success"
                      disabled={formik.values.pessoa.flagOrigem == "SEAP"}
                      type="submit"
                    />
                  </div>
                </div>
              </form>
            </CardSeplag>
          </TabPanel>
          <TabPanel header="Vínculos" headerTemplate={tab2HeaderTemplate}>
            <Vinculo
              idenPessoa={formik.values.pessoa.idenPessoa}
              numrCpf={formik.values.pessoa.numrCpf}
              isPodeEditar={form.pessoa.flagOrigem !== "SEAP"}
            ></Vinculo>
          </TabPanel>
          <TabPanel header="Perfil de Acesso" headerTemplate={tab3HeaderTemplate}>
            <Perfil
              idenPessoa={formik.values.pessoa.idenPessoa}
              isPodeEditar={form.pessoa.flagOrigem !== "SEAP"}
            ></Perfil>
          </TabPanel>
        </TabView>
      </CardSeplag>
    </>
  );
};

export default Usuario;
